export default function ArticleHero() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Thoughtfully%20styled%20desk%20scene%20with%20open%20laptop%20showing%20colorful%20spreadsheet%20data%20beside%20a%20steaming%20ceramic%20mug%20and%20a%20small%20potted%20succulent%20warm%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20creating%20soft%20shadows%20on%20the%20light%20wooden%20surface%20modern%20productive%20workspace%20with%20cozy%20aspirational%20lifestyle%20aesthetic%20editorial%20photography&width=1920&height=1080&seq=pandabuy-article-hero-guide-v3&orientation=landscape"
          alt="Pandabuy Spreadsheet Buying Guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto pt-20">
        <div className="flex items-center gap-2 text-white/60 text-xs mb-6">
          <span>Home</span>
          <span>&gt;</span>
          <span>Blog</span>
          <span>&gt;</span>
          <span className="text-white/90">Guides</span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight">
          COMPLETE
          <br />
          PANDABUY SHEET
          <br />
          BUYING GUIDE
        </h1>
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-6 mt-6">
          <span className="text-sm text-white/70">Published June 28, 2026</span>
          <span className="hidden sm:block text-white/30">·</span>
          <span className="text-sm text-white/70">8 min read</span>
          <span className="hidden sm:block text-white/30">·</span>
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full border border-white/30 text-white/80 whitespace-nowrap">
            Beginner's Guide
          </span>
        </div>
      </div>
    </section>
  );
}